import { ColourVariant } from '@weareopenr/component-library';

export const SCHEDULE_COLOUR_PALETTE: ColourVariant[] = ['tomato', 'honey', 'blueberry', 'grape', 'kale'];

export const resolveScheduleColour = (colourOrder: number | null, isDefault: boolean): ColourVariant => {
  if (isDefault) return 'liquorice';
  return SCHEDULE_COLOUR_PALETTE[(colourOrder ?? 0) % SCHEDULE_COLOUR_PALETTE.length];
};
